import filter from 'lodash/filter'
import first from 'lodash/first'
import groupBy from 'lodash/groupBy'
import { useMemo } from 'react'
import { calculateRelativeChange } from './helperFunctions'

type RegionGeoMapData = {
  name: string
  bewegung: string
  _2022: number
  _2023: number
}

export const useDataForAuswanderung = (
  region: string,
  data: RegionGeoMapData[]
) => {
  const {
    groupedForPopulation,
    zuzuege_2023,
    fortzuege_2023,
    saldo,
    relativeChangeFortzüge,
    relativeChangeZuzüge,
  } = useMemo(() => {
    const filteredForRegion = filter(data, (d) => d.name === region)
    const groupedForPopulation = groupBy(filteredForRegion, 'bewegung')
    const zuzuege_2023 =
      first<RegionGeoMapData>(groupedForPopulation['Zuzüge'])?._2023 || 0
    const fortzuege_2023 =
      first<RegionGeoMapData>(groupedForPopulation['Fortzüge'])?._2023 || 0
    const zuzuege_2022 =
      first<RegionGeoMapData>(groupedForPopulation['Zuzüge'])?._2022 || 0
    const fortzuege_2022 =
      first<RegionGeoMapData>(groupedForPopulation['Fortzüge'])?._2022 || 0
    const saldo = zuzuege_2023 - fortzuege_2023
    const relativeChangeZuzüge = calculateRelativeChange(
      zuzuege_2022,
      zuzuege_2023
    )
    const relativeChangeFortzüge = calculateRelativeChange(
      fortzuege_2022,
      fortzuege_2023
    )

    return {
      groupedForPopulation,
      zuzuege_2023,
      fortzuege_2023,
      saldo,
      relativeChangeFortzüge,
      relativeChangeZuzüge,
    }
  }, [data, region])

  return {
    groupedForPopulation,
    zuzuege_2023,
    fortzuege_2023,
    saldo,
    relativeChangeFortzüge,
    relativeChangeZuzüge,
  }
}
